exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content-wrapper {\n  text-align: center;\n}\n.media img {\n  width: 150px;\n}\n.content {\n  margin-top: 20px;\n}\n.content > span {\n  font-size: 22px;\n}\n.content .small-letters {\n  margin-top: 30px;\n  font-size: 16px;\n}\n", ""]);

// exports
